<div class="header">
  <div class="box">?</div>
  <h1>{{'activities.onboarding-old-learner-start-lessons-pop-up-header' | translate}}</h1>
</div>
<div class="body">
  {{'activities.onboarding-old-learner-start-lessons-pop-up-body' | translate}}
</div>
@if (data?.isInSnackbar) {
  <button (click)="onClick()">{{'snackbar.ok' | translate}}</button>
}
